import { render, staticRenderFns } from "./PatientPaymentShow.vue?vue&type=template&id=510293fe&scoped=true&"
import script from "./PatientPaymentShow.vue?vue&type=script&lang=js&"
export * from "./PatientPaymentShow.vue?vue&type=script&lang=js&"
import style0 from "./PatientPaymentShow.vue?vue&type=style&index=0&id=510293fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510293fe",
  null
  
)

export default component.exports